import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStateInReview = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.55553 4.8H6.77776C6.30627 4.8 5.85409 4.98964 5.52069 5.32721C5.1873 5.66477 5 6.12261 5 6.6V19.2C5 19.6774 5.1873 20.1352 5.52069 20.4728C5.85409 20.8104 6.30627 21 6.77776 21H17.4443C17.9158 21 18.368 20.8104 18.7014 20.4728C19.0348 20.1352 19.2221 19.6774 19.2221 19.2V18.75M15.6666 4.8H17.4443C17.7561 4.80032 18.0623 4.88365 18.3322 5.04162C18.6021 5.19958 18.8262 5.42664 18.9821 5.7M8.55553 17.4H9.44441M9.44441 3H14.7777C15.2686 3 15.6666 3.40294 15.6666 3.9V5.7C15.6666 6.19706 15.2686 6.6 14.7777 6.6H9.44441C8.95349 6.6 8.55553 6.19706 8.55553 5.7V3.9C8.55553 3.40294 8.95349 3 9.44441 3ZM20.447 12.5634C20.8011 12.2049 21 11.7186 21 11.2116C21 10.7046 20.8011 10.2183 20.447 9.8598C20.0929 9.50128 19.6126 9.29987 19.1119 9.29987C18.6111 9.29987 18.1309 9.50128 17.7768 9.8598L14.2124 13.4706C14.001 13.6845 13.8463 13.9488 13.7626 14.2392L13.0186 16.8222C12.9963 16.8996 12.995 16.9817 13.0147 17.0599C13.0345 17.138 13.0747 17.2094 13.131 17.2664C13.1873 17.3234 13.2578 17.3641 13.335 17.3841C13.4121 17.4041 13.4932 17.4028 13.5697 17.3802L16.1208 16.6269C16.4076 16.5421 16.6687 16.3855 16.8799 16.1715L20.447 12.5634Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgStateInReview);
export { ForwardRef as ReactComponent };
